import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { apiUsuariosInstance, authHeaderUsuarios } from "../../redux/actions/usuarios/usuarios";

import { Form, Input, Select, Button, Row, Col, Typography, Space } from "antd";
import { toast } from "../../components/toasts/toastStore";

import "./EventosPage.css";
import "./PaquetesPage.css";

const { Title, Text } = Typography;

export default function CrearUsuarioPage() {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [saving, setSaving] = useState(false);
  const [roles, setRoles] = useState([]);

  useEffect(() => {
    apiUsuariosInstance.get("/usuarios/roles", { headers: authHeaderUsuarios() })
      .then((res) => setRoles(res.data?.items ?? []))
      .catch(() => toast.error("No se pudieron cargar los roles"));
  }, []);

  const handleSave = async () => {
    let values;
    try {
      values = await form.validateFields();
    } catch {
      return;
    }
    const payload = {
      id_rol: values.id_rol,
      nombre: values.nombre?.trim(),
      usuario: values.usuario?.trim(),
      password: values.password,
      email_recuperacion: values.email_recuperacion?.trim() || null,
    };
    setSaving(true);
    try {
      const res = await apiUsuariosInstance.post("/usuarios", payload, { headers: authHeaderUsuarios() });
      toast.success("Usuario creado exitosamente");
      navigate(`/app/usuarios/${res.data?.id}`);
    } catch (err) {
      toast.error(err?.response?.data?.detail || err.message || "Error al guardar");
    } finally {
      setSaving(false);
    }
  };

  return (
    <main className="paq-main">
      <div className="paq-content">
        <section className="cc-page-header-card">
          <Space direction="vertical" size={2}>
            <Title level={2} className="eventos-title" style={{ marginBottom: 0 }}>Nuevo usuario</Title>
            <Text className="eventos-subtitle">Crea la cuenta; despues asigna sus permisos por modulo en el detalle.</Text>
          </Space>
          <Space>
            <Button className="eventos-btn-clean" onClick={() => navigate("/app/usuarios")} disabled={saving}>Cancelar</Button>
            <Button
              type="primary"
              loading={saving}
              icon={<i className="fa-solid fa-plus" />}
              onClick={handleSave}
              style={{ backgroundColor: "#f90336", borderColor: "#f90336" }}
            >
              Crear usuario
            </Button>
          </Space>
        </section>

        <Form form={form} layout="vertical">
          <div className="cc-section-card">
            <div className="cc-section-header">
              <span className="cc-section-icon"><i className="fa-solid fa-user"></i></span>
              Datos de la cuenta
            </div>
            <Row gutter={16}>
              <Col xs={24} md={12}>
                <Form.Item name="nombre" label={<span className="paq-field-label">Nombre completo</span>} rules={[{ required: true, message: "Requerido" }]}>
                  <Input placeholder="Ej. Maria Lopez" autoComplete="off" />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item name="id_rol" label={<span className="paq-field-label">Rol</span>} rules={[{ required: true, message: "Requerido" }]}>
                  <Select placeholder="Selecciona un rol" options={roles.map((r) => ({ value: r.id_rol, label: r.nombre }))} />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col xs={24} md={12}>
                <Form.Item name="usuario" label={<span className="paq-field-label">Usuario (para iniciar sesion)</span>} rules={[{ required: true, message: "Requerido" }]}>
                  <Input placeholder="Ej. mlopez" autoComplete="off" />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  name="password"
                  label={<span className="paq-field-label">Contrasena</span>}
                  rules={[{ required: true, message: "Requerido" }, { min: 6, message: "Minimo 6 caracteres" }]}
                >
                  <Input.Password placeholder="Minimo 6 caracteres" autoComplete="new-password" />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col xs={24} md={12}>
                <Form.Item name="email_recuperacion" label={<span className="paq-field-label">Correo de recuperacion (opcional)</span>} rules={[{ type: "email", message: "Correo invalido" }]}>
                  <Input placeholder="correo@ejemplo.com" autoComplete="off" />
                </Form.Item>
              </Col>
            </Row>
          </div>
        </Form>
      </div>
    </main>
  );
}
